import { formatRubles } from "@shared/utils/number/formatRubles";
import styles from "./PriceDisplay.module.scss";

interface PriceDisplayProps {
  totalPrice: number;
  originalPrice?: number;
  discount?: number;
  className?: string;
}

/**
 * Компонент для отображения цены с учетом промокода
 * Показывает original_price зачеркнутым слева от total_price, если есть скидка
 */
export function PriceDisplay({ 
  totalPrice, 
  originalPrice, 
  discount = 0,
  className 
}: PriceDisplayProps) {
  const hasDiscount = discount > 0 && originalPrice !== undefined && originalPrice > totalPrice;

  return (
    <div className={`${styles.container}${className ? ` ${className}` : ""}`}>
      {hasDiscount && (
        <span className={styles.originalPrice}>
          {formatRubles(originalPrice)}
        </span>
      )}
      <span className={styles.totalPrice}>
        {formatRubles(totalPrice)}
      </span>
    </div>
  );
}

